export default __webpack_public_path__ + "static/media/export.f6e8f390.svg";